import {
	ATTRIBUTE_SYSTEM_ID,
	ATTRIBUTE_SYSTEM,
} from '@netx/core-attribute/constants';

export const UPGRADED_FEATURES = ['attributes'];

export const GOO_SETTING_KEYS = <const>[
	'contactMessage',
	'detailAttributes',
	'googleAnalyticsEnabled',
	'googleAnalyticsId',
	'homeRoute',
	'logoutUrl',
	'requireLogin',
	'searchCategory',
	'searchCategoryName',
	'searchCategoryPath',
	'sortAttributes',
	'ssoLabel',
	'ssoLoginEnabled',
	'ssoUrl',
	'upgradedFeatures',
];
export const SETTING_KEYS = <const>[
	'attributeIds',
	'category',
	'categoryName',
	'categoryPath',
	'displayCatDescriptions',
	'label',
	'path',
	'searchPlaceholder',
	'userLevel',
];

export const ATTRIBUTE_CONTEXT = <const>{
	DETAIL: 'detailAttributes',
	SORT: 'sortAttributes',
};

export const DEFAULT_ATTRIBUTE_IDS = <const>[
	ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.NAME],
	ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.FILE_SIZE_2],
	ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.FILE_TYPE_LABEL],
	ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.DIMENSIONS],
];

export const ENFORCE_ATTRIBUTE_IDS = <const>[
	ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.FILE],
	ATTRIBUTE_SYSTEM_ID[ATTRIBUTE_SYSTEM.NAME],
];
